<template>
  <div>
    <v-list-item dense>
      <ListItemAvatar :user-id="comment.userId" :avatar-options="{ 'size': 30 }" />
      <v-list-item-content dense>
        <v-list-item-title>
          {{ userName }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ fromNow(comment.timestamp) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item style="min-height: 20px">
      <v-list-item-content class="py-0 commentContent">
        <span>{{ comment.content }}</span>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import ListItemAvatar from '@/shared/components/avatar/ListItemAvatar';
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { types as usersTypes } from '@/shared/store/users';

export default {
  name: 'Comment',
  components: {
    ListItemAvatar,
  },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getUserName: usersTypes.getters.userName,
    }),
    userName() {
      const name = this.getUserName(this.comment.userId);
      if (name.length === 0) {
        this.getUserProfile(this.comment.userId);
      }
      return name;
    },
  },
  methods: {
    ...mapActions({
      getUserProfile: usersTypes.actions.getUserProfile,
    }),
    fromNow(timestamp) {
      return moment(timestamp).fromNow();
    },
  },
};
</script>
<style scoped>
.commentContent span {
  font-size: 14px;
  white-space: pre-wrap;
}
</style>
